import { render, staticRenderFns } from "./RevisionTypesFilter.vue?vue&type=template&id=e8ff86ec"
import script from "./RevisionTypesFilter.vue?vue&type=script&lang=js"
export * from "./RevisionTypesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports